var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5B69",
    d: "M10 18.541c-.259 0-.509-.033-.717-.108C6.099 17.341 1.04 13.466 1.04 7.741c0-2.916 2.358-5.283 5.258-5.283 1.409 0 2.725.55 3.7 1.533a5.178 5.178 0 0 1 3.7-1.533c2.9 0 5.259 2.375 5.259 5.283 0 5.734-5.059 9.6-8.242 10.692a2.157 2.157 0 0 1-.717.108ZM6.3 3.708c-2.209 0-4.009 1.808-4.009 4.033 0 5.692 5.475 8.859 7.4 9.517.15.05.475.05.625 0 1.917-.658 7.4-3.817 7.4-9.517 0-2.225-1.8-4.033-4.008-4.033a3.96 3.96 0 0 0-3.2 1.617c-.234.316-.767.316-1 0a3.975 3.975 0 0 0-3.209-1.617Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.bfcc1d5bc99cd7c680a6bc6a89907d5b.svg";
export { ForwardRef as ReactComponent };